
export default function Portfolio() {
  return (
    <section id="how-it-works" className="py-24 px-6 lg:px-12 bg-[#FAFAF9]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm mb-6">
            <span className="w-2 h-2 bg-[#093a3e] rounded-full animate-pulse"></span>
            <span className="text-xs font-semibold text-gray-700 uppercase tracking-wide">How It Works</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Deploy in weeks, improve for the full measurement year.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Step 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="flex items-start gap-6">
              <div className="w-14 h-14 bg-[#093a3e] text-white rounded-full flex items-center justify-center flex-shrink-0 text-2xl font-bold">
                1
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Identify your population and baseline screening rates
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  We analyze your eligible population, establish baseline performance, and segment by geography, site, and engagement likelihood.
                </p>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="flex items-start gap-6">
              <div className="w-14 h-14 bg-[#093a3e] text-white rounded-full flex items-center justify-center flex-shrink-0 text-2xl font-bold">
                2
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Design workflows that fit into existing care delivery
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  We integrate screenings into your existing workflows to minimize downtime and maximize return.
                </p>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="flex items-start gap-6">
              <div className="w-14 h-14 bg-[#093a3e] text-white rounded-full flex items-center justify-center flex-shrink-0 text-2xl font-bold">
                3
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Deploy embedded staff and mobile teams
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Our dual approach combines in-clinic screening for high-volume settings with mobile outreach for hard-to-reach members.
                </p>
              </div>
            </div>
          </div>

          {/* Step 4 */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="flex items-start gap-6">
              <div className="w-14 h-14 bg-[#093a3e] text-white rounded-full flex items-center justify-center flex-shrink-0 text-2xl font-bold">
                4
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Document results and coordinate follow-up care
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Automated results generation, clear escalation pathways for positive findings, and referral coordination support.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          <a
            href="/our-process"
            className="inline-flex items-center gap-3 bg-[#093a3e] text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#062b2f] transition-all shadow-lg hover:shadow-xl hover:gap-4 cursor-pointer whitespace-nowrap"
          >
            <span>See How It Works</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
